import React, {Component} from 'react'
import {Radio, Row, Col} from 'antd';
import CameraLiveStream from './CameraLiveStream'
import CameraSnapshot from './CameraSnapshot'

class CameraView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: this.props.mode
    };
  }

  handleChange(e) {
    this.setState({mode: e.target.value})
  }

  render() {
    const {id, live, snapshot, name} = this.props
    return <div>
      <div className="card-video">
        {
          this.state.mode === 'live'
            ? <CameraLiveStream videoID={id} target={live}/>
          : <CameraSnapshot target={snapshot}/>
        }
      </div>
      <div className="card-video-name">
        <Row type="flex" align="middle" justify="center">
          <Col span={12}>
            <h4>{name}</h4>
          </Col>
          <Col>
            <Radio.Group value={this.state.mode} onChange={(e) => this.handleChange(e)}>
              <Radio.Button value="live">Live</Radio.Button>
              <Radio.Button value="snapshot">Snapshot</Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
      </div>
    </div>
  }
}

export default CameraView;



// WEBPACK FOOTER //
// ./src/components/CameraView.js